import store from '@/store'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

type ActivityAccessContext = {
  to: RouteLocationNormalized
  next: NavigationGuardNext
}

// The Activity dashboard is only available to users who administer at least
// one tenant (administratedTenants from the user profile).
const activityAccess = async ({ to, next }: ActivityAccessContext): Promise<void> => {
  const isAuth = localStorage.getItem('token')

  if (!isAuth) {
    sessionStorage.setItem('userRequestUrl', JSON.stringify({ name: to.name, query: to.query, params: to.params }))
    return next({ name: 'login' })
  }

  if (!(store as any).state.user.currentUser) {
    await (store as any).dispatch('user/getCurrentUserAccount')
  }

  if ((store as any).state.user.currentUser?.administratedTenants?.length) {
    return next()
  }

  return next({ name: 'home' })
}

export default activityAccess
